import React from 'react'
import PropTypes from 'prop-types'
import styles from './style/application_style.module.scss'
import Typography from '../../foundations/typography/Typography'
import ProgressBar from '../../basics/progress-bar/ProgressBar'
import Icon, { IconMap } from '../../foundations/icon/Icon'

const Application = ({ children, className = '', ...props }) => {
    return (
        <div className={`${styles.application} ${className}`} {...props} >
            <div className={`${styles['application-header']}`}>
                <Icon img={props.icon} {...props} />
                <Typography className={`${styles['application-text']}`} typeface="title-s-light" {...props} >
                    {children}
                </Typography>
            </div>
            <ProgressBar level={props.level} />
        </div>
    )
};

Application.propTypes = {
    level: PropTypes.number.isRequired,
    icon: PropTypes.oneOf(Object.keys(IconMap)).isRequired
}

export default Application;